import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Ticket, Plus, Trash2 } from "lucide-react";

export function TicketsTab({ ticketTypes, addTicketType, removeTicketType, updateTicketType, ticketSaving, saveTicketTypes }) {
  return (
    <div className="space-y-6" data-testid="tickets-tab">
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-white font-semibold flex items-center gap-2"><Ticket className="h-4 w-4 text-[#0099CC]" /> Configuration des tarifs</h3>
            <p className="text-[#64748b] text-xs mt-1">Definissez les types de billets et leurs prix. Les billets a 0 EUR sont gratuits (inscription directe).</p>
          </div>
          <Button data-testid="add-ticket-type-btn" onClick={addTicketType} size="sm" className="bg-[#0099CC] hover:bg-[#0088B5] text-white">
            <Plus className="h-3.5 w-3.5 mr-1" /> Ajouter
          </Button>
        </div>

        {ticketTypes.length === 0 ? (
          <div className="text-center py-8">
            <Ticket className="h-10 w-10 text-[#2A3441] mx-auto mb-3" />
            <p className="text-[#64748b]">Aucun type de billet configure</p>
            <p className="text-[#4A5568] text-xs mt-1">Ajoutez des billets pour activer la vente en ligne (Stripe).</p>
          </div>
        ) : (
          <div className="space-y-3">
            {ticketTypes.map((t, i) => (
              <div key={t.id} className="bg-[#151B2B] border border-[#2A3441] rounded-xl p-4" data-testid={`ticket-type-${i}`}>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <div className="col-span-2 sm:col-span-1">
                    <label className="text-[10px] text-[#64748b] mb-1 block">Nom du billet</label>
                    <Input value={t.name} onChange={e => updateTicketType(t.id, "name", e.target.value)} placeholder="Ex: VIP, Standard, Early Bird" className="bg-[#0B0F19] border-[#2A3441] text-white text-sm" />
                  </div>
                  <div>
                    <label className="text-[10px] text-[#64748b] mb-1 block">Prix (EUR)</label>
                    <Input type="number" step="0.01" min="0" value={t.price} onChange={e => updateTicketType(t.id, "price", parseFloat(e.target.value) || 0)} className="bg-[#0B0F19] border-[#2A3441] text-white text-sm" />
                  </div>
                  <div>
                    <label className="text-[10px] text-[#64748b] mb-1 block">Quantite</label>
                    <Input type="number" min="1" value={t.quantity} onChange={e => updateTicketType(t.id, "quantity", parseInt(e.target.value) || 1)} className="bg-[#0B0F19] border-[#2A3441] text-white text-sm" />
                  </div>
                  <div className="flex items-end">
                    <button onClick={() => removeTicketType(t.id)} className="text-red-400 hover:text-red-300 p-2 rounded-lg hover:bg-red-500/10 transition-colors"><Trash2 className="h-4 w-4" /></button>
                    {t.price <= 0 && <span className="text-xs text-[#10B981] ml-2">Gratuit</span>}
                    {t.price > 0 && <span className="text-xs text-[#F59E0B] ml-2">Stripe</span>}
                    {t.sold > 0 && <span className="text-xs text-[#64748b] ml-2">{t.sold} vendu(s)</span>}
                  </div>
                </div>
                <div className="mt-2">
                  <Input value={t.description || ""} onChange={e => updateTicketType(t.id, "description", e.target.value)} placeholder="Description (optionnel)" className="bg-[#0B0F19] border-[#2A3441] text-white text-xs" />
                </div>
              </div>
            ))}
          </div>
        )}

        {ticketTypes.length > 0 && (
          <div className="flex justify-end mt-4">
            <Button data-testid="save-tickets-btn" onClick={saveTicketTypes} disabled={ticketSaving} className="bg-[#0099CC] hover:bg-[#0088B5] text-white">
              {ticketSaving ? "Enregistrement..." : "Enregistrer les tarifs"}
            </Button>
          </div>
        )}
      </div>

      {/* Payment info */}
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6 space-y-3">
        <h3 className="text-white font-semibold text-sm">Comment ca fonctionne</h3>
        <div className="grid sm:grid-cols-3 gap-3 text-xs text-[#94A3B8]">
          <div className="bg-[#151B2B] rounded-lg p-3"><span className="text-[#0099CC] font-bold text-lg block mb-1">1</span>Configurez vos tarifs ci-dessus et enregistrez</div>
          <div className="bg-[#151B2B] rounded-lg p-3"><span className="text-[#0099CC] font-bold text-lg block mb-1">2</span>Partagez le lien public de l'evenement (ou via WhatsApp)</div>
          <div className="bg-[#151B2B] rounded-lg p-3"><span className="text-[#0099CC] font-bold text-lg block mb-1">3</span>Les participants paient via Stripe et sont automatiquement inscrits</div>
        </div>
      </div>
    </div>
  );
}
